import VimeoPlayer from "@vimeo/player";

class FeaturedVideo {
    constructor(element) {
        this.iframe = element;

        if (this.iframe.src.includes("vimeo")) {
            this.player = new VimeoPlayer(element);
            this.player_type = "vimeo";
        }

        if (this.iframe.src.includes("youtube")) {
            this.player = this.iframe.contentWindow;
            this.player_type = "youtube";
        }

        if (!this.player) return;

        this.init();
    }

    init() {
        const btns = document.querySelectorAll("[data-pause-featured-video]");
        btns.forEach((btn) => {
            // If mobile don't autoplay
            if (window.matchMedia("(max-width: 75em)").matches) {
                btn.classList.remove("playing");
            }
            btn.addEventListener("click", this.playPause.bind(this));
        });

        // If mobile don't autoplay
        if (window.matchMedia("(max-width: 75em)").matches) {
            const remove_autoplay = this.iframe.src.replace("&autoplay=1", "");
            this.iframe.src = remove_autoplay;
        }
    }

    playPause(e) {
        if (e.currentTarget.classList.contains("playing")) {
            if (this.player_type == "vimeo") {
                this.player.pause();
            }
            if (this.player_type == "youtube") {
                this.player.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*",
                );
            }
            e.currentTarget.classList.remove("playing");
        } else {
            if (this.player_type == "vimeo") {
                this.player.play();
            }
            if (this.player_type == "youtube") {
                this.player.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*",
                );
            }
            e.currentTarget.classList.add("playing");
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const videos = document.querySelectorAll(".featured-video iframe");

    videos.forEach((element) => {
        new FeaturedVideo(element);
    });
});
